module.exports = __webpack_public_path__ + "img/x-black.39999588.svg";